<template>
    <transition
        v-on:enter="enterSearch"
        v-on:leave="leaveSearch"
        tag="div">
        <div v-show="searchOn" id="search-overlay">
            <div class="search-overlay-header">
                <div class="inner container">
                    <div class="site-logo">
                        <a href="/" class="home-link">
                            <img :src="logoUrl" alt="BAHR">
                        </a>
                    </div>
                    <div class="close-search" v-on:click="closeSearch()" >
                        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                <g id="Mobil-search" transform="translate(-334.000000, -19.000000)" stroke="#FFFFFF" stroke-width="2">
                                    <g id="Close" transform="translate(266.000000, 15.000000)">
                                        <g id="Group-2" transform="translate(69.000000, 5.000000)">
                                            <path d="M0.714285714,0.714285714 L19.2857143,19.2857143" id="Line"></path>
                                            <path d="M0.714285714,0.714285714 L19.2857143,19.2857143" id="Line" transform="translate(10.000000, 10.000000) scale(-1, 1) translate(-10.000000, -10.000000) "></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span>{{strings.close}}</span>
                    </div>
                    <div class="global-search-input">
                        <input ref='search' id="gsi" type="text" v-model="searchInputValue" v-on:keyup="search()" :placeholder="searchInputPlaceholder"/>
                        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Søk" transform="translate(-99.000000, -202.000000)" stroke-width="2" stroke="#FFFFFF"><g id="Search" transform="translate(100.000000, 198.000000)"><g id="Icon:-Search"><g transform="translate(0.000000, 5.000000)"><path d="M13.5,13.5 L19.5,19.5" id="Line" fill="#343638" stroke-linecap="square"></path><circle id="Oval" cx="7.5" cy="7.5" r="7.5"></circle></g></g></g></g></g></svg>
                        <barPreloader v-if="loading" />
                    </div>
                </div>
            </div>

            <transition-group
                v-on:before-enter="beforeEnterAnimation"
                v-on:enter="enterAnimation"
                v-on:leave="leaveAnimation"
                tag="div" v-if="results" class="container global-search-results">
                <div style="margin-bottom: 40px;" class="search-resoultat-roup" v-if="results[postType] && results[postType][0]" v-for="(resArr, postType) in results" :key="postType">
                    <h4 class="search-post-type-name">{{results[postType][0].post_type}}</h4>
                    <a class="search-result" v-if="results[postType]" v-for="(res, ind) in results[postType]" :href="res.slug"  :key="ind" >
                        <span class="title" v-html="res.title"></span>
                        <svg width="20" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M19.77 4.29L15.688.227a.781.781 0 00-1.102 1.108l2.74 2.728H.781a.781.781 0 100 1.562h16.545l-2.74 2.727a.781.781 0 101.102 1.108l4.082-4.063a.782.782 0 000-1.106z" fill="#000" fill-rule="nonzero"/></svg>
                    </a>
                </div>

            </transition-group>
            <div v-if="(!loading && !results )" class="global-search-no-results">{{startSearch}}</div>


        </div>
    </transition>
</template>

<script>
    import barPreloader from './components/barPreloader.vue';
    import axios from 'axios';
    import _debounce from 'lodash.debounce';
    import {TweenMax, TimelineMax} from "gsap";

    export default {
        name: 'Search',
        components: {
            'barPreloader' : barPreloader,
        },
        data() {
            return {
               searchOn: false,
               startSearch: '', //theme_data.strings.type_to_start,
               no_found_text: theme_data.strings.no_found,
               strings: theme_data.strings,
               logoUrl: theme_data.logo_url_white,
               searchInputPlaceholder: theme_data.strings.search_input_placeholder,
               searchInputValue: '',
               results: { },
               loading: false,
               orderedObject: {
                   'employees': [],
                   'expertise': [],
                   'post': [],
                   'arrangementer': [],
                   'page': [],

               }
            }
        },
        mounted() {
            const self = this;
            jQuery(document).ready(function ($) {
                $('#search-overlay-trigger').on('click', function() {
                    self.openSearch();
                });
                $('#search-overlay-trigger-404').on('click', function() {
                    self.openSearch();
                });
                $(window).keydown(function(evt) {
                    if (evt.which == 27) {
                        self.closeSearch();
                    }
                });
            });
        },
        methods: {
            enterSearch(el,done){
                const tl = new TimelineMax({
                    onComplete: done
                })

                tl.set(el, {
                    autoAlpha: 0,
                    opacity: 0,
                    //rotationX: 90,
                    transformOrigin: '50% 50%'
                })

                tl.to(el, 0.3, {
                    autoAlpha: 1,
                    opacity: 1,
                    //rotationX: 0,
                    ease: Power4.easeOut
                })
            },
            leaveSearch(el,done){
                const tl = new TimelineMax({
                    onComplete: done
                })

                tl.set(el, {
                    autoAlpha: 1,
                    opacity: 1,
                    //rotationX: 0,
                    transformOrigin: '50% 50%'
                })

                tl.to(el, 0.3, {
                    autoAlpha: 0,
                    opacity: 0,
                    //rotationX: 90,
                    ease: Power4.easeOut
                })
            },
            beforeEnterAnimation: function(el) {
                el.style.opacity = 0
                el.style.height = 0
            },
            enterAnimation(el, done){
                //var delay = el.dataset.index * 150
                const tm = new TimelineMax({
                });
                tm.set(el, {
                    scale: 0.9,
                    opacity: -1,
                    y: 20,
                    //height: '0%',
                    transformOrigin: '50% 50%',
                    ease: Back.easeInOut.config(0.3),
                });

                setTimeout(function () {
                    tm.to(el, 0.25, {
                            opacity: 1,
                            y: 0,
                            scale: 1,
                            height: '100%',
                            onCompleteParams:["{self}"],
                            onComplete: function(ele){
                                done;
                               // TweenMax.to(ele.target, 0.6, { scale: 1 }, '+=0.5' )
                            }
                        } );
                }, 0.2)
            },
            leaveAnimation(el, done){
                TweenMax.to(el, 0.2, { opacity: 0, height: 0, scale: 0, onComplete: done }, '+=0.2' )
            },

            openSearch() {
                this.searchOn = true;
                jQuery('body').addClass('search-on');
                this.$nextTick(function () {
/*                  this.$refs.search.focus() */
                    setTimeout(function() {
                        jQuery(document).find('#gsi').focus();
                    },50)
                });
            },
            closeSearch() {
                this.searchOn = false;
                this.searchInputValue = '';
                this.results = {};
                this.startSearch = theme_data.strings.type_to_start;
                jQuery('body').removeClass('search-on');
            },
            search: _debounce(function() {
                const self = this;
                if(self.searchInputValue.length >= 3) {
                    self.loading = true;
                    axios.get( theme_data.api+'bahr/v2/search/', {
                        params: {
                            query: self.searchInputValue,
                            lang: theme_data.language,
                        }
                    })
                    .then(response => {
                        self.startSearch = self.no_found_text;
                        if(response.data.posts_data){

                            const assignbyTypes = response.data.posts_data.reduce((acc, item) => {
                                acc[item.type] = [...acc[item.type] || [], item];
                                return acc;
                            }, {});


                            self.results = Object.assign(this.orderedObject, assignbyTypes);

                        }else{
                            self.results = []
                        }

                        self.loading = false;
                    })
                    .catch(error => {
                        console.log('Error!', error);
                        self.loading = false;
                    });
                }
            }, 250)
        }
    }
</script>



// WEBPACK FOOTER //
// src/js/vue/Search.vue?eff95b40